var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeychelles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 39.9999C31.0459 39.9999 40.0003 31.0456 40.0003 19.9999C40.0003 8.95418 31.0459 -0.00012207 20.0002 -0.00012207C8.95455 -0.00012207 0.000244141 8.95418 0.000244141 19.9999C0.000244141 31.0456 8.95455 39.9999 20.0002 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5006 5.24505C29.9428 1.98786 25.2037 -3.05176e-05 19.9999 -3.05176e-05C19.148 -3.05176e-05 18.3086 0.0536414 17.4847 0.157001L7.82602 11.3043L0.632812 25.0102C1.0975 26.8118 1.80797 28.5145 2.72461 30.0818L19.9999 20L33.5006 5.24505Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6509 31.081L8.66899 36.481C11.89 38.6998 15.793 39.9999 20 39.9999C26.947 39.9999 33.0656 36.4575 36.6509 31.081V31.081Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5035 5.24762L2.73607 30.1011C3.54083 31.4736 4.50435 32.7417 5.60177 33.8799L40 19.9999C40 14.1593 37.496 8.90403 33.5035 5.24762V5.24762Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 20C3.05176e-05 21.7302 0.219874 23.409 0.632921 25.0102L17.4848 0.156982C7.62644 1.39401 3.05176e-05 9.8062 3.05176e-05 20Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeychelles);
export default __webpack_public_path__ + "static/media/seychelles.337241fcdfa7e42006d3d14d1d06304a.svg";
export { ForwardRef as ReactComponent };